import { useContext } from 'react';
import { GlobalStore, StoreContext } from '@roc/feature-app-core';
import { LienPayoffReviewStore } from '../store/lienPayoffReviewStore';

/** Reads the root store from context, so it works in any portal that creates lienPayoffReviewStore (client portals and borrower portal). */
export const useLienPayoffReviewStore = () =>
  useContext<{
    lienPayoffReviewStore: LienPayoffReviewStore;
    globalStore: GlobalStore;
  }>(StoreContext);
